import { render, staticRenderFns } from "./colDetails.vue?vue&type=template&id=65bb1334&scoped=true"
import script from "./colDetails.vue?vue&type=script&lang=js"
export * from "./colDetails.vue?vue&type=script&lang=js"
import style0 from "./colDetails.vue?vue&type=style&index=0&id=65bb1334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb1334",
  null
  
)

export default component.exports